var exports = {
  "Nr": "card__YP6j-k",
  "R_": "heading__H3TOn3",
  "ir": "reference__m9089L",
  "hZ": "stateIcon__QPJSOX",
  "n5": "referenceText__fHrVqn",
  "ai": "number__ohKpFV",
  "FM": "repositoryButton__r1hzOB",
  "MK": "menu__ZmRnTZ",
  "DD": "title__Ro3HnD",
  "OA": "fields__G8Ijj4",
  "aB": "fieldTooltip__7B2U0A",
  "dC": "fieldValueToken__atfcFc",
  "CB": "subIssuesProgressCircle__4vNrFN",
  "VK": "parentIssueToken__IhCmqq",
  "J_": "parentIssueState__xZXoc1",
  "kJ": "tooltipHidden__jIuCtR",
  "UK": "assigneeButton__1JVlWS",
  "Jf": "labelOverflowButton__eqYo01",
  "bi": "labelOverflowList__uvtPCs",
  "Hy": "assignees__iBVU9v",
  "qr": "footer__D7uiy9",
  "OF": "footerDate__hHWqbt",
  "zG": "footerTime__DUZ7cc",
  "me": "separator__1zC7bp",
  "CH": "authorButton__sKdRew",
  "vL": "assigneeItem__Smxt-P",
};

module.exports = exports;
